import React, { useEffect } from "react";

import {
  Padding,
  Layout,
  Sheet,
  Container,
  CollapsableItemList,
  ReportTitle,
  Text,
} from "@kidslivesafe/sc-react";

import "./notes.css";

import { useAppSelector } from "../../../hooks/hooks";
import {
  selectAllReportNotesList,
  selectNotesStatus,
} from "../../../features/reports/reportsSlice";
import NoteLineItem from "../../../components/UIComponents/NoteLineItem/NoteLineItem";

const Notes: React.FC = () => {
  const notes = useAppSelector(selectAllReportNotesList);
  const sortedNotes = notes
    ? [...notes].sort((a, b) => {
        const aDate = a.lastActivityDate;
        const bDate = b.lastActivityDate;

        if (aDate > bDate) {
          return -1;
        }
        if (aDate < bDate) {
          return 1;
        }
        return 0;
      })
    : [];
  const notesStatus = useAppSelector(selectNotesStatus);
  const loading = notesStatus === "loading";

  return (
    <>
      <ReportTitle reportTitle="Your Notes" />
      <Sheet>
        <Padding space="md" bottom="lg">
          <Layout type="flex" flexProps={{ direction: "column", gap: "md" }}>
            <Container>
              <CollapsableItemList numberToShow={100}>
                {loading ? (
                  Array(5)
                    .fill(null)
                    .map((_, index) => (
                      <NoteLineItem
                        key={index}
                        note={undefined}
                        loading={loading}
                        loadingKey={index}
                      />
                    ))
                ) : sortedNotes && sortedNotes.length > 0 ? (
                  sortedNotes.map(note =>
                    note && note.reportNotesCount !== 0 ? (
                      <NoteLineItem
                        key={note.id}
                        note={note}
                        loading={loading}
                        loadingKey={note.lastActivityDate}
                      />
                    ) : null,
                  )
                ) : (
                  <Padding space="md">
                    <Text>No Notes</Text>
                  </Padding>
                )}
              </CollapsableItemList>
            </Container>
          </Layout>
        </Padding>
      </Sheet>
    </>
  );
};

export default Notes;
